import { REDO_CART_TOKEN_STORAGE_KEY } from "@redotech/redo-storefront-web/cache/keys";
import { getSessionStorageWithExpiry } from "@redotech/redo-web/utils/session-storage-wrapper";

// Latest cart token, refreshed as the cart changes; lets cart mutations target the live cart.
export const getFreshCartToken = (): string | undefined =>
  getSessionStorageWithExpiry(REDO_CART_TOKEN_STORAGE_KEY);
